// extracted by mini-css-extract-plugin
export var desktopImage = "imageholder-module--desktopImage--1e63d";
export var hasMobile = "imageholder-module--hasMobile--15f19";
export var imageHolder = "imageholder-module--imageHolder--87a76";
export var imageLoading = "imageholder-module--imageLoading--67ac3";
export var mobileImage = "imageholder-module--mobileImage--d115c";